import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import { useState, useRef, useEffect } from "react";
import { useRenderRef, useUnstableReference } from "@tkww/orion-web-lib-react";
export const useThrottledState = (state, delay) => {
  const [finalState, setFinalState] = useState(state);
  const stableState = useUnstableReference(state);
  const lastStateRef = useRenderRef(stableState);
  const timerRef = useRef(null);
  const delayRef = useRenderRef(delay);
  const isMountedRef = useRef(false);
  useEffect(() => {
    isMountedRef.current = true;
    if (!timerRef.current) {
      timerRef.current = _setTimeout(() => {
        timerRef.current = null;
        if (isMountedRef.current) {
          setFinalState(lastStateRef.current);
        }
      }, delayRef.current);
      return () => {
        isMountedRef.current = false;
      };
    }
  }, [stableState]);
  return finalState;
};